import * as React from 'react'

import { Box, type Colors, Icon, NumberBadge, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import * as styles from './index.vanilla.css'
import VerticalLineSVG from './verticalLineSVG'

interface CardData {
  badgeBackgroundColour: Colors
  badgeTextColour: Colors
  title: string
  subtitle: string
  description: string
  mins: number
}

const getCardsData: (isSoftwareSection?: boolean) => CardData[] = (isSoftwareSection) => [
  {
    badgeBackgroundColour: 'viridian200',
    badgeTextColour: 'viridian1000',
    title: i18n.t('expenses_v2.cards.blocks.steps_section.cards.first.title'),
    subtitle: i18n.t('expenses_v2.cards.blocks.steps_section.external_window'),
    description: i18n.t('expenses_v2.cards.blocks.steps_section.cards.first.description'),
    mins: 8,
  },
  {
    badgeBackgroundColour: 'viridian600',
    badgeTextColour: 'grey000White',
    title: i18n.t('expenses_v2.cards.blocks.steps_section.cards.second.title'),
    subtitle: i18n.t('expenses_v2.cards.blocks.steps_section.factorial_app'),
    description: i18n.t('expenses_v2.cards.blocks.steps_section.cards.second.description'),
    mins: 1,
  },
  {
    badgeBackgroundColour: 'viridian1000',
    badgeTextColour: 'grey000White',
    title: isSoftwareSection
      ? i18n.t('expenses_v2.cards.blocks.steps_section.cards.software.title')
      : i18n.t('expenses_v2.cards.blocks.steps_section.cards.third.title'),
    subtitle: i18n.t('expenses_v2.cards.blocks.steps_section.factorial_app'),
    description: isSoftwareSection
      ? i18n.t('expenses_v2.cards.blocks.steps_section.cards.software.description')
      : i18n.t('expenses_v2.cards.blocks.steps_section.cards.third.description'),
    mins: isSoftwareSection ? 3 : 1,
  },
]

interface Props {
  isSoftwareSection?: boolean
}

const Steps: React.FC<Props> = ({ isSoftwareSection }) => {
  const cardsData = getCardsData(isSoftwareSection)

  return (
    <Box>
      <div className={styles.timeLine}></div>
      <Box flexDirection="row" justifyContent="spaceAround" alignItems="stretch">
        {cardsData.map(({ badgeBackgroundColour, badgeTextColour }, i) => (
          <div key={i}>
            <div className={styles.numberBagdeContainer}>
              <NumberBadge
                label={i + 1}
                color={badgeBackgroundColour}
                textColor={badgeTextColour}
              />
            </div>
            <div className={styles.verticalLine}>
              <VerticalLineSVG />
            </div>
          </div>
        ))}
      </Box>
      <Box flexDirection="row" justifyContent="spaceAround" alignItems="stretch" gap="s48">
        {cardsData.map(({ title, subtitle, description, mins }) => (
          <Box
            key={title}
            flexDirection="column"
            justifyContent="spaceBetween"
            maxWidth="s400"
            padding="s24"
            gap="s16"
            className={styles.card}
          >
            <Box gap="s16">
              <Box gap="s1">
                <Text.Normal htmlTag="h3" weight="medium">
                  {title}
                </Text.Normal>
                <Text size="200" weight="normal" color="grey600">
                  {subtitle}
                </Text>
              </Box>
              <Box>
                <Text.Normal>{description}</Text.Normal>
              </Box>
            </Box>
            <Box flexDirection="row" gap="s4" alignItems="center">
              <Icon.Medium icon="clock" color="grey700" />{' '}
              <Text size="200" color="grey700">
                {`${mins} ${i18n.t('expenses_v2.cards.blocks.steps_section.minutes_abbreviation')}`}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default Steps
